import {
  CheckOutlined,
  CloseOutlined,
  InfoCircleOutlined,
  LeftOutlined,
} from "@ant-design/icons";
import { Button, Card, Col, Divider, Row } from "antd";
import React from "react";
import { useParams } from "react-router-dom";
import SegmentLists from "./segment_lists";
import { useSelector } from "react-redux";
import {
  draftDialogAudioUrlSelector,
  draftDialogDetailSelector,
} from "store/bailiff/draft/dialog/draft_dialog.selector";
import { useDialogQC } from "hook/draft/dialog/useDialogsQC";
import AudioUrl from "component/audio/audio_url";

//
//component
//redux
//selector
//actions
//utils
//hook
//str
const SegmentDetail = () => {
  // -------------------------- VAR -----------------------------
  const { loading, handleOpenDeny, handleRatePass, handleOpenWarn } =
    useDialogQC();

  const params = useParams();
  const { bailiffId } = params;
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const url = useSelector(draftDialogAudioUrlSelector);
  const data = useSelector(draftDialogDetailSelector);
  const rated = data?.rated || false;
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const renderActions = () => {
    return (
      <Row gutter={[10, 10]}>
        <Col xl={8} lg={8} md={24} xs={24}>
          <Button
            loading={loading}
            onClick={handleRatePass}
            style={{ borderRadius: 5 }}
            disabled={rated}
            block
            icon={<CheckOutlined style={{ color: "green" }} />}
          >
            Đạt
          </Button>
        </Col>
        <Col xl={8} lg={8} md={12} xs={12}>
          <Button
            onClick={handleOpenWarn}
            style={{ borderRadius: 5 }}
            disabled={rated}
            block
            icon={<InfoCircleOutlined style={{ color: "orange" }} />}
          >
            Cảnh Cáo
          </Button>
        </Col>
        <Col xl={8} lg={8} md={12} xs={12}>
          <Button
            onClick={handleOpenDeny}
            style={{ borderRadius: 5 }}
            disabled={rated}
            block
            icon={<CloseOutlined style={{ color: "red" }} />}
          >
            Không Đạt
          </Button>
        </Col>
      </Row>
    );
  };
  // -------------------------- MAIN ----------------------------
  return (
    <Card style={{ marginTop: 30 }} size="small">
      <Row>
        <Col align="left" xl={24} lg={24} md={24} xs={24}>
          <Button
            href={`/bailiff/${bailiffId}`}
            size="large"
            type="link"
            style={{ textDecoration: "underline" }}
            icon={<LeftOutlined />}
          >
            Trích đoạn
          </Button>
        </Col>
        <Col style={{ marginTop: 20 }} xl={24} lg={24} md={24} xs={24}>
          {renderActions()}
        </Col>
        <Col xl={24} lg={24} md={24} xs={24}>
          <SegmentLists />
        </Col>
        <Divider plain>Nghe lại</Divider>
        <Col xl={24} lg={24} md={24} xs={24}>
          <AudioUrl url={url} />
        </Col>
      </Row>
    </Card>
  );
};
export default SegmentDetail;
